import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-coming-soon',
  templateUrl: './feature-coming-soon.component.html',
  styleUrls: ['./feature-coming-soon.component.scss']
})
export class FeatureComingSoonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
